module.exports = __webpack_public_path__ + "static/media/Cases.Icon.b46ba5bc.svg";